/* eslint-disable max-params */
/* eslint-disable camelcase */
import each from "lodash/fp/each";
import isNil from "lodash/fp/isNil";

class Controller {
  constructor(
    $mdDialog,
    $state,
    $injector,
    activeContract,
    contractSteps,
    corporateId
  ) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.$state = $state;
    this.Events = $injector.get("Events");
    this.ContractsResource = $injector.get("Contracts");
    this.contractSteps = contractSteps;
    this.corporateId = corporateId;
    this.selectedBuses = [];
    this.selected_routes = [];
    this.contract = {
      penalty_plan: [],
      deduction_plan: [],
    };
    this.activeContract = activeContract;
    this.account_managers = [];
    this.corporateTransform = $injector.get("CorporateTransforms");
    this.successEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
    this.selectRouteEvent = this.Events.getSelectRouteEvent();
    this.Events.on(this.selectRouteEvent, this.onSelectRoute.bind(this));
    this.confirm = this.confirm.bind(this);
    this.stepperEvents = { routesEvent: this.selectRouteEvent };
    // Don't close till the the process done successfully
    this.shouldClose = false;
  }

  $onInit() {
    if (!isNil(this.activeContract)) {
      this.contractSteps.forEach((step) => {
        if (step.name === "type") {
          step.show = false;
          step.value = this.activeContract.contractType;
        } else if (step.name === "selected_buses") {
          step.show = true;
          step.value = this.activeContract.selectedBuses;
          this.selectedBuses = this.activeContract.selectedBuses;
          if (step.conditional && step.conditional.name === "selected_routes") {
            step.conditional.value = this.activeContract.selectedRoutes;
            this.selected_routes = this.activeContract.selectedRoutes;
          }
        } else if (step.name === "pricing") {
          step.value = this.activeContract.subscriptions;
        } else if (step.name === "penalty_plan") {
          step.value = this.activeContract.penaltyPlan;
        } else if (step.name === "deduction_plan") {
          step.value = this.activeContract.deductionPlan;
        } else if (step.name === "start_date") {
          step.value = this.activeContract.startDate;
        } else if (step.name === "expiry_date") {
          step.value = this.activeContract.expiryDate;
        }
      });
    }
  }
  createContract(body) {
    this.ContractsResource.post(body).then(
      (response) => {
        this.Events.emit(this.successEvent, {
          message: "Contract created successfully",
        });
        this.response = response;
        this.shouldClose = true;
        this.navigateToCorporate();
      },
      (response) => {
        if (response.data.details) {
          each((detail) =>
            this.Events.emit(this.errorEvent, { message: detail.message })
          )(response.data.details);
        }

        if (response.data.errors) {
          each((detail) =>
            this.Events.emit(this.errorEvent, { message: detail.message })
          )(response.data.errors);
        }
      }
    );
  }

  resetSteps() {
    this.contractSteps.map((step, index) => {
      if (index === 0) step.show = true;
      else step.show = false;
      return step;
    });
  }

  navigateToCorporate() {
    this.resetSteps();
    this.$state.transitionTo(
      "corporate",
      { id: this.corporateId },
      { reload: true }
    );
  }

  onSelectRoute(selectedRoute) {
    if (isNil(selectedRoute) || selectedRoute === "") return;
    this.contract.tempRoute = "";

    // Adding new route if not exist in selected routes
    if (
      this.selected_routes.every((route) => route._id !== selectedRoute._id)
    ) {
      this.selected_routes.push(selectedRoute);
    }
    this.contract.selected_routes = this.selected_routes;
  }

  confirm() {
    const justifiedContract = this.corporateTransform.justifyContract({
      ...this.contract,
      corporate: this.corporateId,
    });
    this.createContract(justifiedContract);
    if (this.shouldClose) {
      this.$mdDialog.hide(this.response);
      this.resetSteps();
    }
  }

  close() {
    this.resetSteps();
    this.$mdDialog.cancel();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/corporate/contractDialog/contractDialog.controller.js